export default __webpack_public_path__ + "static/media/keyvisual-traunstein-trostberg.84416712.jpg";